export default {
  props: {
    banner: {
      type: String,
      default: '',
    },
  },
};
